import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import { ThemeProvider } from "styled-components";
import NotificationUI from "ati-ui-react/widgets/Notification";
import Preloader from "./components/Preloader";
import Template from "./components/Common/Template";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import BridgeCapitalPage from "./components/BridgeCapitalPage";
import GlobalStyles from "./globalStyles";
import theme from "./theme";
import { useStore } from "./store";
import Popup from "./components/Popup/Popup";

const App: FC = () => {
  const { globalModule, notificationModule } = useStore();
  const { firmName, loadedLoans } = globalModule;
  const { notification, removeNotification } = notificationModule;

  return (
    <ThemeProvider theme={theme}>
      <Template.Wrapper>
        <Template.Main>
          <NotificationUI
            closeNotification={removeNotification}
            message={notification.message}
            show={notification.show}
            type={notification.type}
          />
          <ErrorBoundary>
            {loadedLoans
              ? <BridgeCapitalPage companyName={firmName} />
              : <Preloader />}
          </ErrorBoundary>
        </Template.Main>
        <Popup />
      </Template.Wrapper>
      <GlobalStyles />
    </ThemeProvider>
  );
};

export default observer(App);
